import { useState } from "react";
import { faqs } from "@/mocks/manga";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs tracking-widest text-primary-400 mb-2">常见问题 · FAQ</p>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
            你想知道的都在这里
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((item, i) => {
            const open = openIndex === i;
            return (
              <div
                key={item.q}
                className={`rounded-lg border overflow-hidden transition-colors ${
                  open ? "border-primary-500/50 bg-background-100" : "border-background-300/40 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-sm md:text-base font-bold text-foreground-950">
                    {item.q}
                  </h3>
                  <span
                    className={`shrink-0 w-7 h-7 rounded-md flex items-center justify-center transition-all ${
                      open
                        ? "bg-primary-600 text-foreground-950 rotate-45"
                        : "bg-background-200/60 text-foreground-500"
                    }`}
                  >
                    <i className="ri-add-line text-base"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm text-foreground-400 leading-relaxed">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}